import React, { ReactElement } from 'react'
import BasketQuantity from './BasketQuantity'
import CuttingInstructions from './CuttingInstructions'
import { BasketItemModel } from './types/models'
import { formatNumberString, formatPriceString } from '../../common/helpers/number-formatters'
import ProductImage from './ProductImage'

type BasketItemProps = {
  includeVat: boolean;
  item: BasketItemModel;
  onCuttingInstructionsChanged: (
    item: BasketItemModel, instructions: string, offcutsRequired: boolean,
  ) => void;
  onItemRemoved: (id: number, discount_id: number) => void;
  onQuantityChanged: (id: number, quantity: string) => void;
}

const BasketBuyItem = ({
  includeVat, item, onCuttingInstructionsChanged, onItemRemoved, onQuantityChanged
}: BasketItemProps): ReactElement => (
  <>
    <hr className="basketDivider" />
    <div className="new-basket-item">
      <div className="basket-item-image basket-item-info">
        {
          item.image &&
            <ProductImage
              title={item.image.title}
              urls={item.image.urls}
            />
        }
      </div>

      <div className="basket-item-details basket-item-info">
        <div className="basket-item-header">
          {
            item.brand &&
              <div className="product-brand">{item.brand}</div>
          }
          <div className="basket-item-product-name">{item.product_name}</div>
          {
            item.feature_descriptions && !item.product.cuttable &&
              <div className="basket-item-feature-descriptions">{item.feature_descriptions}</div>
          }
        </div>

        {
          item.cutting_options_url &&
            <a id="cuttingOptionsLink" href={item.cutting_options_url}>Cutting Options</a>
        }

        <CuttingInstructions
          item={item} onCuttingInstructionsChanged={onCuttingInstructionsChanged} />

        {
            <div className="basket-item-footer">
              <button className="basket-item-remove-button" onClick={(): void => onItemRemoved(item.id, item.discount_id)}>Remove</button>
            </div>
        }
      </div>

      <div className="basket-item-weight basket-item-info basket-item-single-line">
        <span className="mobile-only">Weight:&nbsp;</span>
        <span className="v-center">{formatNumberString(item.weight, 2)}&nbsp;kg</span>
      </div>

      <div className="basket-item-unit-price basket-item-info basket-item-single-line">
        <span className="mobile-only">Unit Price:&nbsp;</span>
        <span className="v-center">
          { item.reward ? 'FREE' : formatPriceString(includeVat ? item.product_price_inc_vat : item.product_price_ex_vat) }
        </span>
      </div>

      <div className="basket-item-quantity basket-item-info basket-item-single-line">
        <span className="mobile-only">Quantity:&nbsp;</span>
          {
            item.reward
              ? <div className="discount-quantity v-center">{item.quantity}</div>
              : <div className="product-quantity-container">
                  <BasketQuantity item={item} onQuantityChanged={onQuantityChanged} />
                </div>
          }
      </div>

      <div className="basket-item-total basket-item-info basket-item-single-line">
        <span className="mobile-only">Total:&nbsp;</span>
        <span className="v-center">
          { item.reward ? 'FREE' : formatPriceString(includeVat ? item.line_total_inc_tax : item.line_total_ex_tax) }
        </span>
      </div>
    </div>
  </>
)

export default BasketBuyItem
